import { createSelector } from 'reselect'
import { AppState } from 'store/types'
import { selectAllBooksWithProgress } from '../Book'
import { LearningJourneyEntityType } from '../Journey'
import { getProcessedRecommendedItem, getProcessedShelves } from './Library.utils'

export const selectLibraryContent = createSelector(
  (state: AppState) => state.library.libraryContent,
  selectAllBooksWithProgress,
  (libraryContent, booksWithProgress) => {
    const { shelves, recommendedContent } = libraryContent

    const isSupportedRecommendedContent =
      recommendedContent?.type === LearningJourneyEntityType.Book ||
      recommendedContent?.type === LearningJourneyEntityType.LevelUp

    return {
      recommendedItem: isSupportedRecommendedContent
        ? getProcessedRecommendedItem(recommendedContent, booksWithProgress)
        : null,
      shelves: getProcessedShelves(shelves, booksWithProgress)
    }
  }
)

export const selectShouldRefetchLibrary = (state: AppState) => state.library.shouldRefetchLibrary

export function selectTimeSpent(state: AppState): number {
  return state.library.timeSpent
}

export function selectDailyGoal(state: AppState): number {
  return state.library.dailyGoal
}

export const selectProgressPercentage = createSelector(selectDailyGoal, selectTimeSpent, (dailyGoal, timeSpent) => {
  return Math.round((timeSpent / dailyGoal) * 100)
})
